module.exports = __webpack_public_path__ + "img/duoke.bf4f893f.png";